import React from 'react';
import {Link as RouterLink,useHistory} from 'react-router-dom';
import Link from '@mui/material/Link';
import {Container, Grid, Button} from '@mui/material'
import {PartnerSiteService} from '../../../services';
import CustomDataGrid from '../../../customUtil/DataGrid';

const columns = [
    {
        field: 'oneNetCode', headerName: 'One Net Code', width: 130,
        renderCell: (params) => (
            <Link style={{textDecoration: 'none'}} component={RouterLink} to={'/references/partner-site/' + params.row.id}>
                {params.value}
            </Link>
        )
    },
    {field: 'partnerName', headerName: 'Name', width: 200},
    {field: 'countryName', headerName: 'Country', width: 130, 
    valueGetter: (params) => params.row?.country.countryName ,
      },
    {field: 'countryCode', headerName: 'Country Code', width: 130, 
    valueGetter: (params) => params.row?.country.countryCode ,
      },
    {field: 'address', headerName: 'Address', width: 330}
]

const PartnerSites = () => {
        const [list, setList] = React.useState([]);
        const history = useHistory();

        React.useEffect(() => {
            PartnerSiteService.getAll()
                .then((response) => setList(response.data));
        }, []);

        return (
            <div>
                <Container>
                    <header>
                        <h1>Partner Sites (Ship-to)</h1>
                    </header>
                    <Grid container spacing={5}>                   
                        <Grid item xs={12}>
                        <Button variant='contained' color='primary' onClick={() => {history.push('/references/partner-site/new')}}>Create New</Button>
                        </Grid>                      
                          <Grid item xs={12}>
                        <CustomDataGrid 
                                rows={list}
                                columns={columns}
                                rowHeight={35}
                                components={false}
                                pageSize={10}/>            
                        </Grid>
                    </Grid>
                </Container>
            </div>
        );
    }
;

export default PartnerSites;
